module.exports = __webpack_public_path__ + "media/images/icons/up-triangle-a7dd5b9e6f0db1785ddd4374bf4550f7.svg";